<template>
    <v-dialog v-model="dialog" width="1400" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div class="w-75 text-truncate text-white">
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-row>
                    <v-col cols="12">
                        <v-card class="pa-2 d-flex flex-column fill-height" elevation="3">
                            <v-card-text>
                                <div class="text-h6 font-weight-black">{{ complianceData.compliance_name }}</div>
                                <div class="text-body-2 font-weight-bold mt-4">Schedules</div>
                                <v-row class="mt-2" dense v-for="schedule in complianceData.schedules" :key="schedule">
                                    <v-col v-if="complianceData.is_term_separated" cols="12">
                                        <b>{{ schedule.term.name }}</b>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        Deadline: <b>{{ formatDate(schedule.deadline) }}</b>
                                    </v-col>
                                    <v-col v-if="schedule.is_extended" cols="12" md="6">
                                        Deadline Extension: <b>{{ formatDate(schedule.deadline_extension) }}</b>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <v-tabs v-model="selectedTab" align-tabs="start" color="darkGreen" @update:modelValue="initReportPerInstitute()">
                            <v-tab :class="{'font-weight-black': selectedTab == institute.id}" v-for="institute in instituteData" :key="institute.id" :value="institute.id">
                                {{ institute.abbrev }}
                            </v-tab>
                        </v-tabs>
                        <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12">
                        <div class="font-weight-black">Submissions Percentage(%)</div>
                    </v-col>
                    <v-col v-if="complianceData.is_term_separated == true" cols="12">
                        <v-select
                            v-model="term"
                            :items="termData"
                            label="Selected Term"
                            variant="outlined"
                            hide-details
                            density="compact"
                            rounded="lg"
                            color="primary"
                            item-title="name"
                            item-value="value"
                            style="max-width: 350px;"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card elevation="4">
                            <v-card-title class="text-subtitle-1 font-weight-bold">Before Deadline</v-card-title>
                            <v-card-text>
                                <div class="text-h4 text-green-accent-4">{{ submissionStats.before.percent }}%</div>
                                <div>({{ submissionStats.before.count }}/{{ facultyStatuses.length }})</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    
                    <v-col cols="12" md="3">
                        <v-card elevation="4">
                            <v-card-title class="text-subtitle-1 font-weight-bold">On Deadline</v-card-title>
                            <v-card-text>
                            <div class="text-h4 text-teal-accent-4">{{ submissionStats.on.percent }}%</div>
                            <div>({{ submissionStats.on.count }}/{{ facultyStatuses.length }})</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card elevation="4">
                            <v-card-title class="text-subtitle-1 font-weight-bold">After Deadline</v-card-title>
                            <v-card-text>
                            <div class="text-h4 text-orange-accent-3">{{ submissionStats.after.percent }}%</div>
                            <div>({{ submissionStats.after.count }}/{{ facultyStatuses.length }})</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card elevation="4">
                            <v-card-title class="text-subtitle-1 font-weight-bold">Not Submitted</v-card-title>
                            <v-card-text>
                            <div class="text-h4 text-red-accent-3">{{ submissionStats.not.percent }}%</div>
                            <div>({{ submissionStats.not.count }}/{{ facultyStatuses.length }})</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <div class="font-weight-black">Faculty Submission Status</div>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select
                        v-model="selectedEmployment"
                        :items="employmentOptions"
                        label="Filter by Employment Status"
                        variant="outlined"
                        clearable
                        density="compact"
                        hide-details
                        rounded="lg"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select
                        v-model="selectedProgram"
                        :items="programOptions"
                        label="Filter by Program"
                        variant="outlined"
                        clearable
                        density="compact"
                        hide-details
                        rounded="lg"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select
                        v-model="selectedStatus"
                        :items="statusOptions"
                        label="Filter by Status"
                        variant="outlined"
                        clearable
                        density="compact"
                        hide-details
                        rounded="lg"
                        ></v-select>
                    </v-col>
                    <v-col cols="12">
                        <v-card class="dt-container">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="filteredData"
                                :search="search"
                                :loading="loading"
                                :items-per-page="30"
                                :items-per-page-options="[30, 40, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.latestSubmission="{ item }">
                                <span>{{ item.latestSubmission }} </span>
                            </template>
                            <template v-slot:item.status="{ item }">
                                <v-chip variant="flat" v-if="item.status == 'before deadline'" color="green-darken-1">Before Deadline</v-chip>
                                <v-chip variant="flat" v-if="item.status == 'on deadline'" color="teal-accent-4">On Deadline</v-chip>
                                <v-chip variant="flat" v-if="item.status == 'after deadline'" color="orange-accent-3 text-white">After Deadline</v-chip>
                                <v-chip variant="flat" v-if="item.status == 'not submitted'" color="red-accent-3">Not Submitted</v-chip>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <div class="d-flex justify-end ga-2">
                                    <v-btn v-show="item.isActive == false" @click="showConfirmDialog(item)" size="small" variant="outlined" text="Activate" color="green-accent-4" elevation="3"></v-btn>
                                    <v-btn @click="showEditDialog(item)" size="small" variant="outlined" text="View" color="green" elevation="3"></v-btn>
                                </div>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Close" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from 'vue'
import axios from 'axios';
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    data () {
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,
            search: null,

            complianceData: null,
            instituteData: [],
            selectedTab: 0,

            headers: [
                { title: 'Faculty Name', align: 'start', sortable: true, key: 'faculty' },
                { title: 'Employment Status', align: 'start', sortable: true, key: 'employment_status' },
                { title: 'Program', align: 'start', sortable: true, key: 'program' },
                { title: 'Status', align: 'start', sortable: true, key: 'status' },
                { title: 'Submission Count / Total Course Load', align: 'end', sortable: true, key: 'submissionCount' },
                { title: 'Latest Submission Date', align: 'end', sortable: true, key: 'latestSubmission' },
            ],

            termData: [
                { name: 'Mid Term', value: 1 },
                { name: 'Final Term', value: 2 }
            ],

            term: 1,

            submissionStats: {
                before: { count: 0, percent: 0 },
                on: { count: 0, percent: 0 },
                after: { count: 0, percent: 0 },
                not: { count: 0, percent: 0 }
            },
            facultyStatuses: [],
            
            selectedEmployment: null,
            selectedProgram: null,
            selectedStatus: null
        }
    },
    watch: {
        term() {
            if (this.complianceData?.is_term_separated) {
                this.initReportPerInstitute();
            }
        }
    },
    computed: {
        employmentOptions(){
            const employment_statuses = new Set(this.facultyStatuses.map(f => f.employment_status || 'N/A'));
            return Array.from(employment_statuses);
        },
        programOptions() {
            const programs = new Set(this.facultyStatuses.map(f => f.program || 'N/A'));
            return Array.from(programs);
        },
        statusOptions() {
            const statuses = new Set(this.facultyStatuses.map(f => f.status));
            return Array.from(statuses);
        },
        filteredData() {
            return this.facultyStatuses
                .filter(f => !this.selectedEmployment || f.employment_status === this.selectedEmployment)
                .filter(f => !this.selectedProgram || f.program === this.selectedProgram)
                .filter(f => !this.selectedStatus || f.status === this.selectedStatus)
                .map(faculty => ({
                    faculty: faculty.name,
                    program: faculty.program || 'N/A',
                    employment_status: faculty.employment_status,
                    status: faculty.status,
                    latestSubmission: faculty.latestSubmission ? this.formatDate(faculty.latestSubmission) : '—',
                    submissionCount: faculty.submissionCount + " / " + faculty.totalFacultyLoad || '—'
                }));
        }
    },
    methods: {
        async initView(complianceData){
            this.dialog = true
            this.dialog_title = complianceData.compliance_name + ' Report'
            this.dialog_sub_title = 'View Report for ' + this.$store.state.semester_schoolyear.semester + ' S.Y. ' + this.$store.state.semester_schoolyear.schoolyear
            this.action = 'view'

            this.complianceData = complianceData
            this.selectedProgram = null
            this.selectedStatus = null

            await axios.get(process.env.VUE_APP_SERVER_URL + '/offices/getAllInstitute')
            .then(res => {
                this.instituteData = res.data
                this.selectedTab = this.instituteData[0].id
            });

            this.initReportPerInstitute()
        },
        async initReportPerInstitute() {
            const { showSnackbar } = useSnackbar()
            this.loading = true;
            const token = localStorage.getItem('aums-token');
            let url = `${process.env.VUE_APP_SERVER_URL}/reports/getComplianceReport/${this.selectedTab}/${this.complianceData.id}/${this.$store.state.semester_schoolyear.id}`;

            if (this.complianceData.is_term_separated) {
                url += `?termId=${this.term}`;
            }

            try {
                const res = await axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                this.loading = false
                const report = res.data;
                this.deadline = report.deadline;
                this.facultyStatuses = report.facultyStatuses;

                this.submissionStats = {
                    before: {
                        count: report.summary.beforeDeadline,
                        percent: report.summary.percentage.beforeDeadline
                    },
                    on: {
                        count: report.summary.onDeadline,
                        percent: report.summary.percentage.onDeadline
                    },
                    after: {
                        count: report.summary.afterDeadline,
                        percent: report.summary.percentage.afterDeadline
                    },
                    not: {
                        count: report.summary.notSubmitted,
                        percent: report.summary.percentage.notSubmitted
                    }
                };
            } catch (error) {
                console.error(error);
                if (error.response?.status === 401) {
                    showSnackbar('Token expired! Logging out..')
                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
            } finally {
                this.loading = false;
            }
        },
        closeDialog(){
            this.dialog = false
        }
    }
})
</script>

<style scoped>

</style>